<!-- <p>badminton-tournament works!</p> -->

<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> International FIDE Rapid Rating Chess Tournament</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>2nd G H Raisoni Memorial Amravati <span>International FIDE Rapid Rating Chess Tournament </span></h2>
        </div>

        <div class="row text-justify">
            <div class="col-lg-12">
                <p>
                    IM Kushagra Mohan of Telangana Clinches Crown at the 2nd G.H. Raisoni Memorial Amravati FIDE Rapid Rating Chess Tournament
                </p>
                <p>Amravati, February 9, 2025 – The 2nd G.H. Raisoni Memorial Amravati FIDE Rapid Rating Chess Tournament concluded successfully with IM Kushagra Mohan from Telangana emerging as the winner. The prestigious event, organized by the G.H. Raisoni Sports and Cultural Foundation, in collaboration with the Kalpana Prakash Welfare Foundation and the Amravati Chess Association, witnessed overwhelming participation.</p>
                <p>The tournament, held under the auspices of the Maharashtra Chess Association, All India Chess Federation, and FIDE, attracted 373 chess enthusiasts from across the country. Among them were two International Masters – IM Kushagra Mohan and IM Ravi Teja. The youngest participant, 4-year-old Advi Ankit Bhngewar, and the oldest player, 86-year-old Ishwar Ramteke, showcased the tournament's diverse appeal.</p>
                <p>IM Kushagra Mohan dominated the event, scoring an impressive 8½ points out of 9 games, clinching the title and a cash prize of Rs. 50,000 along with a sparkling trophy. The runner-up spot was claimed by Nihaan Pohane, an Under-15 player from Chandrapur, who scored 8 points against seasoned players, earning a cash prize of Rs. 30,000.</p>
                <div class="row row-cols-1 row-cols-md-2">
                    <div class="col">
                        <h6 class="fw-bold">The top 10 finishers of the event were:</h6>
                        <ul class="list-style list-style1">
                            <li>IM Kushagra Mohan – 8½ points (Champion)</li>
                            <li>Nihaan Pohane – 8 points (Runner-up)</li>
                            <li>Vaibhav Jayant Raut – 7½ points</li>
                            <li>Pawan Dodeja – 7½ points</li>
                            <li>Shaunak Badole – 7½ points</li>
                            <li>Siddhant Gawai – 7½ points</li>
                            <li>Nachiket Paturkar – 7½ points</li>
                            <li>Vedant Panesar – 7½ points</li>
                            <li>Priyanshu Patil – 7½ points</li>
                            <li>Rajat Kamdi – 7½ points</li>
                        </ul>
                    </div>
                    <div class="col">
                        <h6 class="fw-bold">In addition to the top finishers, cash prizes were awarded to players in several categories:</h6>
                        <ul class="list-style list-style1">
                          <li>Best Veteran (55+)</li>
                          <li>Best Female (18+)</li>
                          <li>Best Amravati Player</li>
                          <li>Best Unrated Player</li>
                          <li>Best Player (Rating 1400-1600)</li>
                          <li>Best Player (Rating 1601-1800)</li>
                        </ul>
                    </div>


                </div>

                </div>


        </div>

      <p>Trophies were presented to the top players in the Under-7, 9, 11, 13, and 15 age categories.</p>
      <p>The prize distribution ceremony was graced by Smt. Vaishali Dhande, IRS, Deputy Commissioner, Central GST, Amravati, who presented awards alongside notable guests, including CA Saket Mehta, Vice Chairman of ICAI, Amravati, and Smt. Vishwaja Wankhede, an ardent cyclist. Dr. Vinayak Deshpande, Vice Chancellor of G.H. Raisoni University, Amravati, presided over the event.</p>
      <p>Tournament officials, including IA Ajinkya Pingale from Mumbai, were assisted by a dedicated team of arbiters and support staff. The event was executed smoothly, ensuring a memorable experience for all participants and attendees.</p>
      <p>For further updates and information on upcoming tournaments, stay connected with the official website of the G.H. Raisoni Sports and Cultural Foundation.</p>

    </div>
</section>

<section class="section section-sm sport-event section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row text-justify">
            <div class="widget_title inner-title">
                <h4>Tournament Organizers: </h4>
            </div>

            <ul class="list-style list-style1">
                <li> G.H. Raisoni Sports and Cultural Foundation.</li>
                <li> Kalpana Prakash Welfare Foundation.</li>
                <li> Amravati Chess Association.</li>
            </ul>
            <div class="widget_title inner-title">
                <h4>Official Recognitions: </h4>
            </div>

            <ul class="list-style list-style1">
                <li> Maharashtra Chess Association.</li>
                <li> All India Chess Federation.</li>
                <li> FIDE.</li>
            </ul>
            <div class="widget_title inner-title">
                <h4>Event Supporters: </h4>
            </div>

            <ul class="list-style list-style1">
                <li> G.H. Raisoni University.</li>
                <li> Amravati Chess Association.</li>
            </ul>
        </div>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-1.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-2.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-3.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-4.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-5.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-5.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-5.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-6.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-6.avif">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/int-fide-rapid-rating-ches-tour-6.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
